import {useCriticalIllnessCoveragePopulator} from '../populator/useCriticalIllnessCoveragePopulator';
import {useDispatch} from 'react-redux';

export const useCriticalIllnessCoverageDispatcher = () => {
    const populateCriticalIllnessCoverage = useCriticalIllnessCoveragePopulator();
    const dispatch = useDispatch();

    const dispatchCoverage = (selectedRate, selectedBenefitKey) => {
        const data = populateCriticalIllnessCoverage(selectedRate, selectedBenefitKey);
        dispatch({
            type: 'UPDATE_MEMBER_ELECTION',
            data: data
        });
    };

    return (selectedRate, selectedBenefitKey) => dispatchCoverage(selectedRate, selectedBenefitKey);
};